<script>
import _ from "lodash";

export default {
  name: "TheAchievementTableForStatementScholarship",

  props: {
    achievements: Array,
    selectedAchievements: Array,
  },

  data() {
    return {
      page: 1,
      itemsPerPage: 10,
      selectedAchievementsByTable: [],
      headers: [
        {
          text: 'Название',
          value: 'name',
          groupable: false,
          sortable: false,
          width: '35%',
        },
        {
          text: 'Тип деятельности',
          value: 'prtf_achievement_type_name',
          groupable: false,
          sortable: false,
          width: '35%',
        },
        {
          text: 'Баллы',
          value: 'score',
          groupable: false,
          sortable: false,
          width: '10%',
        },
        {
          text: 'Дата',
          value: 'date_end',
          groupable: false,
          sortable: false,
          width: '15%',
        },
        {
          text: 'Файл',
          value: 'file.url',
          groupable: false,
          sortable: false,
          width: '5%',
        },
      ]
    }
  },

  watch: {
    selectedAchievementsByTable() {
      return this.$emit("select", this.selectedAchievementsByTable);
    },

    selectedAchievements() {
      return this.selectedAchievementsByTable = this.selectedAchievements;
    },
  },

  computed: {
    numberOfPages () {
      return Math.ceil(this.achievements.length / this.itemsPerPage)
    },

  },

  methods: {
    scoreAchievement(achievement) {
      if (_.isNil(achievement.subunit)) return achievement?.unit?.score || 0;
      return achievement?.subunit?.score || 0;
    },

    dateFormatForTable(olDateFormat) {
      const parts = olDateFormat.split('-');

      const year = parts[0];
      const month = parts[1];
      const day = parts[2];

      return `${day}.${month}.${year}`;
    },

    selectAll({items, value}) {
      if (value) {
        this.selectedAchievementsByTable = this.achievements;
        return;
      }

      if (value && (this.selectedAchievementsByTable !== this.achievements)) {
        this.selectedAchievementsByTable = this.achievements;
        return;
      }

      this.selectedAchievementsByTable = []
    },
  },

}
</script>

<template>
  <v-data-table
    :items="achievements"
    :headers="headers"
    show-select
    height="45vh"
    fixed-header
    v-model="selectedAchievementsByTable"
    key="id"
    checkbox-color="teal darken-3"
    :page.sync="page"
    :items-per-page.sync="itemsPerPage"
    hide-default-footer
    item-key="id"
    @toggle-select-all="selectAll"
  >
    <template #item.score="{item, index}">
      {{scoreAchievement(item)}}
    </template>

    <template #item.date_end="{item, index}">
      {{dateFormatForTable(item.date_end)}}
    </template>

    <template #item.file.url="{item, index}">
      <v-btn
        fab
        small
        elevation="0"
        :href="item.file.url"
        target="_blank"
      >
        <v-icon small>fa-search</v-icon>
      </v-btn>
    </template>

    <template #loading>
      Идет загрузка...
    </template>

    <template #no-data>
      Отсутствуют достижения
    </template>

    <template #footer>
      <v-row
        v-if="numberOfPages > 1"
        class="pb-5 px-4 pt-5"
        align="center"
        justify="center">
        <div class="text-center">
          <v-pagination
            circle
            color="teal darken-3"
            v-model="page"
            :length="numberOfPages"
            :total-visible="5">
          </v-pagination>
        </div>
      </v-row>
    </template>

  </v-data-table>
</template>

<style scoped>

</style>